
import NGError from '../../../error/ngError';
import errorFactory from '../../../error/errorFactory';
import {
	WS_PROCESS_MESSAGE_IS_MALFORMED,
	WS_REQUEST_IS_MALFORMED,
} from '../../../error/websocket/errorTypes';
import notificationMapper from './mappers/notificationFlowMapper';
import { publishAndAwait } from '../../../app/coreSlice';

const updateNotification = async ({
	id,
	bcc,
	body,
	subject,
	type,
	subType,
	toSpecificMail,
	specificMailList,
}) => {

	if ( !id || !subject ) {
		throw errorFactory(WS_REQUEST_IS_MALFORMED);
	}

	const request = await publishAndAwait({
		destination: '/app/hello',
		body: {
			type: 'CARCLUB',
			subType: 'EDIT_MESSAGE_CARCLUB',
			message: {
				id,
				bcc,
				body,
				subject,
				type,
				subType,
				toSpecificMail,
				specificMailList,
			},
		},
	});

	const { processMessage, error } = request.response;

	if (!processMessage) {
		throw errorFactory(WS_PROCESS_MESSAGE_IS_MALFORMED);
	}

	if (error) {

		const {
			description,
			code,
			tag,
		} = processMessage;

		throw new NGError({
			message: description,
			code,
			tag,
		});
	}

	const notification = notificationMapper.fromDTO(processMessage);
	return notification;
};

export default updateNotification;